var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BannerWave',{attrs:{"data":_vm.data,"design":_vm.design,"wave":_vm.wave}}),_c('div',{staticClass:"container-map"},[_c('MapWave',{attrs:{"data":_vm.mapData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }